import { Injectable } from '@angular/core';
import { resolve } from 'url';
declare var app;
@Injectable({
  providedIn: 'root'
})
export class IndexdbService {

  db:any=null;
  //数据库名称
  databaseName:any="crmdb";
  constructor() {
   }
   /***
    * 判断是否支持IndexDb
    */
   get IndexDb():any{
    return window.indexedDB || window["mozIndexedDB"] || window["webkitIndexedDB"] || window["msIndexedDB"];
   }
   /**
    * 打开数据库连接
    */
   open():Promise<any>{
     const that=this;
    //  debugger;
    return new Promise<any>((resolve,reason)=>{
      if(that.db){
        resolve(that.db);
      }else{
        try {
          let request = that.IndexDb.open(that.databaseName,app.IndexDB_VERSION);
          request.onupgradeneeded=function(event){
            that.db=event.target.result;
            let tabArray:Array<any> =app.DATABASE_TABLE||[];
            tabArray.forEach(items=>{
              if (!that.db.objectStoreNames.contains(items.table)) {
               let objectStore=that.db.createObjectStore(items.table, { autoIncrement:true });
                  items.columns=items.columns||[];
                  items.columns.forEach(item=>{
                    objectStore.createIndex(item.field, item.field, { unique: item.unique });
                  });
              }
            });
          };
          request.onsuccess=function(event){
            that.db=event.target.result;
            resolve(that.db);
          };
          request.onerror=function(event){
            reason(event);
           };
         }catch(err){
          reason(err);
         }
      }
    });
   }
   /**
    * 新增数据
    */
   Add(tableName:string,data:Array<any>):Promise<any>{
     const that=this;
       return new Promise<any>((resolve,reason)=>{
        that.open().then(db=>{
          let objectStore;
            let transaction= db.transaction([tableName],'readwrite');
            objectStore = transaction.objectStore(tableName);
             data.forEach(items=>{
              objectStore.add(items); 
             });
             resolve(true);
         }).catch(err=>{
          resolve(false);
         });
       })

   }
   /**
    * 查询全部数据
    * @param tableName 
    */
   queryAll(tableName){
    const that=this;
    return new Promise<any>((resolve,reason)=>{
     that.open().then(db=>{
       let objectStore;
         let transaction= db.transaction([tableName],'readwrite');
         objectStore = transaction.objectStore(tableName);
         let request = objectStore.getAll();
         request.onerror = function(event) {
          reason(event);
        };
        request.onsuccess = function(event) {
          resolve(event.target.result);
        }
      }).catch(err=>{
       resolve(err);
      });
    })
   }
   /**
    * 查询数据
    * @param tableName 需要查询的表的名称
    * @param searcherName 查询的数据
    * @param columnName 查询的列
    */
   queryIndex(tableName:string, searcherName:string, columnName:string="key"){
    const that=this;
    debugger;
    return new Promise<any>((resolve,reason)=>{
     that.open().then(db=>{
       let objectStore;
         let transaction= db.transaction([tableName],'readwrite');
         objectStore = transaction.objectStore(tableName);
         let index = objectStore.index(columnName);
         var request = index.get(searcherName);
         request.onerror = function(event) {
          reason(event);
        };
        request.onsuccess = function(event) {
          resolve(event.target.result);
        }
      }).catch(err=>{
       resolve(err);
      });
    })
   }
   /**
    * 删除表
    * @param tableName 
    */
   Delete(tableName){
     const that=this;
     that.IndexDb.deleteDatabase(tableName);
   }
   /**
    * 关闭数据库连接
    */
  CloseDB(){
    const that=this;
   that.db.close();
}
PageAllData(tableName,array:Array<any>):Promise<any>{
  const that=this;
  return new Promise<any>((resolve,reason)=>{
    that.open().then(db=>{
      debugger;
      let objectStore;
        let transaction= db.transaction([tableName],'readwrite');
        let num:number=0;
        objectStore = transaction.objectStore(tableName);
        array.forEach(items=>{
          num++;
          that.query_Index(objectStore,items).then(data=>{
            if(num==array.length){
              resolve(true);
            }
          }).catch(err=>{
            reason(err);
          });
         });
        }).catch(err=>{
          reason(err);
        });
     })
}
private query_Index(db:any,item:any):Promise<any>{
  const that=this;
  return new Promise<any>((resolve,reason)=>{
    let index = db.index("Key");
    let request = index.get(item.Key);
    request.onerror = function(event) {
     reason(event);
   };
    request.onsuccess = function(event) {
      if(event.target.result){
        that.query_update(db,item).then(data=>{
          resolve(event.target.result);
        }).catch(err=>{
          reason(err);
        });
      }else{
        that.query_Add(db,item).then(data=>{
          resolve(event.target.result);
        }).catch(err=>{
          reason(err);
        });
      }
    };
  });
}
private query_Add(db:any,item:any):Promise<any>{
  const that=this;
  return new Promise<any>((resolve,reason)=>{
    let request = db.add(item);
    request.onerror = function(event) {
     reason(event);
   };
    request.onsuccess = function(event) {
      if(event.target.result){
        resolve(event.target.result);
      }else{
        reason(event.target.result);
      }
    };
  });
}
private query_update(db:any,item:any):Promise<any>{
  const that=this;
  return new Promise<any>((resolve,reason)=>{
    let request =  db.put(item);
    request.onerror = function(event) {
     reason(event);
   };
    request.onsuccess = function(event) {
      if(event.target.result){
        resolve(event.target.result);
      }else{
        reason(event.target.result);
      }
    };
  });
}

}
